export default {
    init() {
        this.createUserModal();
        this.showPassword();
        this.createUser();
        this.editUserModal();
        this.editPermissions();
        this.deleteUserModal();
        this.deletePermission();
        this.assignUserModal();
        this.assignUser();
        this.emailSubscriptions();
        // this.getUserInfoEditModal();
    },
    emailSubscriptions() {
        $('body').on('click', '.email_subscriptions', function(e) {
            e.preventDefault();
            let url = $(this).attr('href');
            $.ajax({
                type: 'GET',
                url: url,
                success: function (response) {
                    $('#user_info_content').html(response);
                    $('#user_info_modal').modal('show');
                },
            });
        });
    },
    // TODO: add head class for click for /admin/ url like organisations-cockpit/chat.getUserInfoEditModal() and merge it
    // getUserInfoEditModal() {
    //     $('body').on('click', '.user_info_edit', function(e) {
    //         e.preventDefault();
    //         let id = $('.user_data').data('id');
    //         $.ajax({
    //             type: 'GET',
    //             url: '/admin/user_info_edit/' + id,
    //             success: function (response) {
    //                 $('#user_info_edit').html(response);
    //                 $('#user_info_edit_modal').modal('show');
    //                 // Mask
    //                 $('#phone').mask('ddd-ddd-dddd');
    //                 $('#card_number').mask('?dddd dddd dddd dddd');
    //                 $('#exp_date').mask('dd/dd');
    //             },
    //         });
    //     });
    // },
    createUserModal() {
        $('body').on('click', '#create_new_user', function(e) {
            $('#create_user_modal').modal('show');
            $('.platform-admin-error').removeClass('alert-danger').addClass('d-none');
        });
    },
    showPassword() {
        $('body').on('click', '.eye', function(e) {
            e.preventDefault();
            $('.eye').each(function(i,el) {
                $(el).removeClass('d-none');
            })
            $(this).addClass('d-none');
            let type    = this.id == 'open' ? 'text' : 'password',
                input   = $('input#adm_user_password'),
                replace = input.clone().attr('type', type)
                input.replaceWith(replace);
            $('#open').attr('aria-pressed', type === 'text');
            $('#closed').attr('aria-pressed', type !== 'text');
        });
    },
    createUser() {
        let $this = this;
        $('body').on('click', '#create_user_button', function(e) {
            $('.platform-admin-error').removeClass('alert-danger').addClass('d-none');
            $.ajax({
                type: 'POST',
                url: '/admin/manage-administrative-users/create',
                data: ({
                    first_name: $('#user_first_name').val(),
                    last_name: $('#user_last_name').val(),
                    email: $('#adm_user_email').val(),
                    password: $('#adm_user_password').val(),
                    permission: $('input[name="user_permission"]:checked').val(),
                }),
                success: function (response) {
                    $this.clearForm();
                    $this.usersList();
                    $('#create_user_modal').modal('hide');
                },
                error: function (response) {
                    let errors = response.responseJSON.errors;
                    $.each(errors, function (key) {
                        $('#error_' + key).find('.mb-0').html(errors[key]);
                        $('#error_' + key).addClass('alert-danger');
                        $('#error_' + key).removeClass('d-none');
                    })
                },
                complete: function (response) {

                },
            });
        });
    },
    editUserModal() {
        $('body').on('click', '.admin_users_table .edit', function(e) {
            e.preventDefault();
            $.ajax({
                type: 'GET',
                url: '/admin/manage-administrative-users/user',
                data: ({
                    id: $(this).closest('tr')[0].id,
                }),
                success: function (response) {
                    $('#ed_user_id').text(response.id)
                    $('#ed_name').text(response.first_name + ' ' + response.last_name);
                    $('#ed_permission_' + response.permission).prop('checked', true);
                    $('#edit_user_modal').modal('show');
                },
            });
        });
    },
    editPermissions() {
        let $this = this;
        $('body').on('click', '#edit_user_button', function(e) {
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: '/admin/manage-administrative-users/edit',
                data: ({
                    user_id: $('#ed_user_id').text(),
                    permission: $('input[name="ed_permission"]:checked').val(),
                }),
                success: function (response) {
                    $this.usersList();
                    $('#edit_user_modal').modal('hide');
                },
                error: function (response) {

                },
                complete: function (response) {

                },
            });
        });
    },
    assignUserModal() {
        $('body').on('click', '#assign_user', function(e) {
            $('.platform-admin-error').removeClass('alert-danger').addClass('d-none');
            e.preventDefault();
            $('#assign_modal').modal('show');
        });
    },
    assignUser() {
        let $this = this;
        $('body').on('click', '#assign_user_button', function(e) {
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: '/admin/manage-administrative-users/assign',
                data: ({
                    user_id : $('#as_user_id').val(),
                    user_permission: $('input[name="as_user_permission"]:checked').val(),
                }),
                success: function (response) {
                    $this.usersList();
                    $('#as_user_id').val('');
                    $('input[name="as_user_permission"]').prop('checked', false);
                    $('#assign_modal').modal('hide');
                },
                error: function (response) {
                    let errors = response.responseJSON.errors;
                    $.each(errors, function (key) {
                        $('#error_' + key).find('.mb-0').html(errors[key]);
                        $('#error_' + key).addClass('alert-danger');
                        $('#error_' + key).removeClass('d-none');
                    })
                },
            });
        });
    },
    deleteUserModal() {
        $('body').on('click', '.admin_users_table .del_perm', function(e) {
            e.preventDefault();
            $('#del_user_id').text($(this).closest('tr').find('.user_id').text());
            $('#del_name').text($(this).closest('tr').find('.user_name').text());
            $('#del_permission').text($(this).closest('tr').find('.permission').text());
            $('#delete_user_modal').modal('show');
        });
    },
    deletePermission() {
        let $this = this;
        $('body').on('click', '#del_user_permission_button', function(e) {
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: '/admin/manage-administrative-users/delete',
                data: ({
                    user_id: $('#del_user_id').text(),
                    permission_name: $('#del_permission').text(),
                }),
                success: function (response) {
                    $this.usersList();
                    $('#delete_user_modal').modal('hide');
                },
                error: function (response) {

                },
                complete: function (response) {

                },
            });
        });
    },
    usersList() {
        let params = new URLSearchParams(window.location.search);
        let page = params.get('page');
        $.ajax({
            type: 'GET',
            url: '/admin/manage-administrative-users',
            data: ({
                list: true,
                page: page,
            }),
            success: function (response) {
                $('#administrative-users-table tbody').html(response);
            },
        });
    },
    clearForm() {
        $('#user_first_name').val('');
        $('#user_last_name').val('');
        $('#adm_user_email').val('');
        $('#adm_user_password').val('');
        $('input[name="user_permission"]').prop('checked', false);
    },
}
